import {useContext} from "react";
import {ExpanderTableContext} from "../expander-table"

/**
 * expander-table/hooks/index.js
 *
 * Returns an array containing the current state object, and store action dispatch method
 * Usage: const [state, setState] = useExpanderTable();
 */
// export default useExpanderTable => useContext(ExpanderTableContext);

function useExpanderTable() {
    const {state, setState} = useContext((ExpanderTableContext));
    return [state, setState]
}

export default useExpanderTable;